import { Check, MessageSquare } from "lucide-react";
import { PHONE, PHONE_TEL } from "@/lib/api";

const POINTS = [
  {
    t: "Loan Reinstatement & Forbearance",
    d: "We negotiate with your servicer to pause, catch up, or restructure payments so you can stay in your home.",
  },
  {
    t: "Loan Modification",
    d: "Lower your interest rate, extend your term, or reduce principal so your monthly payment becomes manageable.",
  },
  {
    t: "Short Sale Navigation",
    d: "If you owe more than the home is worth, we coordinate a lender-approved sale that avoids foreclosure on your record.",
  },
  {
    t: "Fast Cash Exit",
    d: "Don't want to fight the bank? Our buyer network can close in days — you walk away with cash, dignity intact.",
  },
  {
    t: "Deed-in-Lieu Consultation",
    d: "A structured handover that protects your credit better than a foreclosure judgment.",
  },
  {
    t: "Credit & Recovery Guidance",
    d: "Whatever path you take, we help you rebuild — so this chapter doesn't define your future.",
  },
];

export default function PreForeclosure() {
  return (
    <section
      id="pre-foreclosure"
      data-testid="pre-foreclosure-section"
      className="py-20 md:py-32 bg-white border-y border-[#E5E3DB]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <div className="mb-4">
            <span className="gold-rule" />
            <span className="text-xs uppercase tracking-[0.24em] text-[#2C5545] font-medium">
              Pre-Foreclosure
            </span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0B1B3D] leading-tight mb-5">
            You have more <em className="font-medium text-[#C5A059] not-italic">options</em> than the bank wants you to know.
          </h2>
          <p className="text-[#64748B] leading-relaxed mb-6">
            A missed mortgage payment is not the end. In most states you have
            between 90 and 180 days before a foreclosure becomes final — and during
            that window, almost every homeowner has at least three viable paths to
            keep their home or walk away with money.
          </p>
          <p className="text-[#64748B] leading-relaxed mb-8">
            We review your loan, your equity, your state's timeline, and your
            personal goals — then build a custom plan in under 24 hours.
          </p>
          <a
            href={`sms:${PHONE_TEL}`}
            data-testid="pre-foreclosure-cta"
            className="inline-flex items-center gap-2 px-7 py-4 rounded-lg bg-[#0B1B3D] hover:bg-[#1A2F5C] text-white font-medium transition-all shadow-md hover:shadow-lg"
          >
            <MessageSquare className="h-4 w-4" />
            Text an advocate — {PHONE}
          </a>
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {POINTS.map((p, i) => (
            <div
              key={i}
              data-testid={`pre-foreclosure-point-${i}`}
              className="rounded-lg border border-[#E5E3DB] bg-[#FAF9F6] p-6 hover:bg-white transition-colors"
            >
              <div className="h-8 w-8 rounded-full bg-[#2C5545] flex items-center justify-center mb-4">
                <Check className="h-4 w-4 text-white" />
              </div>
              <h3 className="font-display text-xl text-[#0B1B3D] mb-2">{p.t}</h3>
              <p className="text-sm text-[#64748B] leading-relaxed">{p.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
